$( document ).ready(function() {
  
  /*Scroll to new products after 5 seconds
  var myAppJavaScript = function($){
    headerHeight = $('#shopify-section-header').outerHeight();
    setTimeout(function(){
    window.location.hash = '#shopify-section-1575899672966'; $('#shopify-section-1575899672966').css('padding-top', headerHeight);
  },5000);*/
  
  //Open - close indicator
  var date = new Date();
  var time = parseInt(date.toLocaleString('en-EN', {hour: '2-digit', minute:'2-digit', hour12: false, timeZone: 'Europe/Paris' }).replace(':', ''));
  var day = date.toLocaleString('en-EN', {weekday:'short', timeZone: 'Europe/Paris' });
  
  
  if(day != 'Sun' && (time >= 1030 && time<= 1930)){
     $('#shop-is-open-text').show();
    
  }else{
  	$('#shop-is-open-text').hide();
    $('#shop-is-closed-text').show();
  }
  


//Load jquery
if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
  loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
    jQuery191 = jQuery.noConflict(true);
   // myAppJavaScript(jQuery191);
  });
} else {
  //myAppJavaScript(jQuery);
}
  
   
  
});